export default __webpack_public_path__ + "static/media/T60.c39bd87f.JPG";